import { createContext, useContext } from 'react'

export type NavigationGuard = (path: string) => boolean

export interface NavigationGuardContextValue {
  registerGuard: (guard: NavigationGuard) => () => void
  guardedNavigate: (path: string) => void
}

export const NavigationGuardContext =
  createContext<NavigationGuardContextValue | null>(null)

export function useNavigationGuard(): NavigationGuardContextValue {
  const ctx = useContext(NavigationGuardContext)
  if (!ctx) {
    throw new Error(
      'useNavigationGuard must be used within a NavigationGuardProvider'
    )
  }
  return ctx
}
